module.exports = __webpack_public_path__ + "img/FR15638.9d0b385d.png";